import { render } from "./ViewChoiceIcons.vue?vue&type=template&id=7515705c&scoped=true"
import script from "./ViewChoiceIcons.vue?vue&type=script&lang=js"
export * from "./ViewChoiceIcons.vue?vue&type=script&lang=js"

import "./ViewChoiceIcons.vue?vue&type=style&index=0&id=7515705c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7515705c"]])

export default __exports__